<script>
import ElCheckbox from 'vue-xpc/src/element-ui/packages/checkbox/src/checkbox.vue';
import ElRadio from 'element-ui/lib/radio';
import { isEqual } from 'element-ui/lib/utils/util';
import RtCheckbox from 'vue-xpc/src/components/checkbox/rtCheckbox.vue';

const stopPropagation = e => e.stopPropagation();

const MAX_HEIGHT = 420;
const MIN_HEIGHT = 204;

export default {
  inject: ['panel', 'ElCascader'],

  components: {
    ElCheckbox,
    ElRadio,
    RtCheckbox
  },

  props: {
    node: {
      type: [Object, Array],
      required: true
    },
    nodeId: String
  },

  data () {
    return {
      isHover: false
    };
  },
  computed: {
    config () {
      return this.panel.config;
    },
    isLeaf () {
      return this.node.isLeaf;
    },
    isDisabled () {
      return this.node.isDisabled;
    },
    checkedValue () {
      return this.panel.checkedValue;
    },
    isChecked () {
      return this.node.isSameNode(this.checkedValue);
    },
    inActivePath () {
      return this.isInPath(this.panel.activePath);
    },
    inCheckedPath () {
      // if (!this.config.checkStrictly) return false;

      return this.panel.checkedNodePaths
        .some(checkedPath => this.isInPath(checkedPath));
    },
    value () {
      return this.node.getValueByOption();
    }
  },

  // watch: {
  //   'ElCascader.dropDownVisible' (val) {
  //     if (val) {
  //       if (this.ElCascader.value.length > 0) {
  //         const cascadeMenu = this.panel.$children.map(menu => {
  //           return this.getNodeLength(menu);
  //         })
  //         let MaxNodeHeight = this.getNodeLength(Math.max.apply(null, cascadeMenu));
  //         let MinNodeHeight = this.getNodeLength(Math.min.apply(null, cascadeMenu));
  //         this.panel.$children && this.panel.$children.forEach((element) => {
  //           let menuWrap = element && element.$el && element.$el.querySelector('.el-cascader-menu__wrap');
  //           if (MaxNodeHeight <= MAX_HEIGHT) {
  //             menuWrap.style['height'] = MAX_HEIGHT + 'px';
  //           } else if (MinNodeHeight < MIN_HEIGHT) {
  //             menuWrap.style['height'] = MIN_HEIGHT + 'px';
  //           } else {
  //             menuWrap.style['height'] = MaxNodeHeight + 'px';
  //           }
  //         });
  //       } else {
  //         const firstCascadeMenu = this.panel && this.panel.$children[0];
  //         let firstNodeHeight = this.getNodeLength(firstCascadeMenu);
  //         if (firstNodeHeight > MAX_HEIGHT) {
  //           this.resizeMenuHeight();
  //         }
  //       }
  //     }
  //   }
  // },

  methods: {
    handleExpand () {
      const { panel, node, isDisabled, config } = this;
      const { multiple, checkStrictly } = config;

      if (!checkStrictly && (isDisabled || node.loading)) return;

      if (config.lazy && !node.loaded) {
        panel.lazyLoad(node, () => {
          // do not use cached leaf value here, invoke this.isLeaf to get new value.
          const { isLeaf } = this;

          if (!isLeaf) this.handleExpand();
          if (multiple) {
            // if leaf sync checked state, else clear checked state
            const checked = isLeaf ? node.checked : false;
            this.handleMultiCheckChange(checked);
          }
        });
      } else {
        panel.handleExpand(node);
      }
      // this.resizeMenuHeight();
    },

    getNodeLength (menu) {
      const nodeLength =
          menu &&
          menu.$el &&
          menu.$el.querySelectorAll('.el-cascader-node').length;
      return nodeLength * 34 + 24;
    },

    resizeMenuHeight () {
      this.$nextTick(() => {
        if (this.isLeaf) return;

        const firstCascadeMenu = this.panel && this.panel.$children[0];
        let firstNodeHeight = this.getNodeLength(firstCascadeMenu);
        if (firstNodeHeight >= MAX_HEIGHT) {
          firstNodeHeight = MAX_HEIGHT;
        } else if (firstNodeHeight <= MIN_HEIGHT) {
          firstNodeHeight = MIN_HEIGHT;
        }

        const nextCascadeMenu = this.panel.$children && this.panel.$children[this.value.length];
        const nextNodeHeight = nextCascadeMenu ? this.getNodeLength(nextCascadeMenu) : 0;

        this.panel.$children && this.panel.$children.forEach((element) => {
          let menuWrap = element && element.$el && element.$el.querySelector('.el-cascader-menu__wrap');
          menuWrap.style['height'] = firstNodeHeight + 'px';
          this.$setTimeout(() => {
            if (nextNodeHeight >= firstNodeHeight && nextNodeHeight <= MAX_HEIGHT) {
              menuWrap.style['height'] = nextNodeHeight + 'px';
            } else if (nextNodeHeight < firstNodeHeight) {
              menuWrap.style['height'] = firstNodeHeight + 'px';
            } else {
              menuWrap.style['height'] = MAX_HEIGHT + 'px';
            }
          }, 0)
        });
      });
    },

    handleCheckChange () {
      const { panel, value, node } = this;
      panel.handleCheckChange(value);
      panel.handleExpand(node);
    },

    handleMultiCheckChange (checked) {
      this.node.doCheck(checked);
      this.panel.calculateMultiCheckedValue();
    },

    isInPath (pathNodes) {
      const { node } = this;
      const selectedPathNode = pathNodes[node.level - 1] || {};
      return selectedPathNode.uid === node.uid;
    },

    renderPrefix (h) {
      const { config } = this;
      const { checkStrictly, multiple } = config;

      if (multiple) {
        return this.renderCheckbox(h);
      } else if (checkStrictly) {
        return this.renderRadio(h);
      }

      return null;
    },

    renderPostfix (h) {
      const { node, isLeaf } = this;

      if (node.loading) {
        return this.renderLoadingIcon(h);
      } else if (!isLeaf) {
        return this.renderExpandIcon(h);
      } else if (isLeaf) {
        // 为最后一级添加勾选图标
        return this.renderLastIcon(h);
      }

      return null;
    },

    renderCheckbox (h) {
      const { node, config, isDisabled } = this;
      const events = {
        on: { change: this.handleMultiCheckChange },
        nativeOn: {}
      };

      if (config.checkStrictly) {
        // when every node is selectable, click event should not trigger expand event.
        events.nativeOn.click = stopPropagation;
      }

      return (
        <rt-checkbox
          value={ node.checked }
          indeterminate={ node.indeterminate }
          disabled={ isDisabled }
          { ...events }
        ></rt-checkbox>
      );
    },

    handleMouseEnter () {
      this.isHover = true;
    },

    handleMouseLeave () {
      this.isHover = false;
    },

    renderRadio (h) {
      let { checkedValue, value, isDisabled } = this;

      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
      if (isEqual(value, checkedValue)) {
        value = checkedValue;
      }

      return (
        <el-radio
          value={ checkedValue }
          label={ value }
          disabled={ isDisabled }
          onChange={ this.handleCheckChange }
          nativeOnClick={ stopPropagation }>
          {/* add an empty element to avoid render label */}
          <span></span>
        </el-radio>
      );
    },

    renderCheckIcon (h) {
      return (
        <i class="el-icon-check el-cascader-node__prefix"></i>
      );
    },

    renderLoadingIcon (h) {
      return (
        <i class="el-icon-loading el-cascader-node__postfix"></i>
      );
    },

    renderLastIcon (h) {
      const { isChecked, config, isHover } = this;
      const { expandTrigger } = config;

      if (isChecked || (isHover && expandTrigger === 'hover')) {
        return (
          <i class="el-icon-check el-cascader-node__postfix"></i>
        );
      }
    },

    renderExpandIcon (h) {
      const { config, inActivePath, inCheckedPath, isLeaf } = this;
      const { checkStrictly, multiple } = config;
      if ((inActivePath && (!checkStrictly && !multiple && isLeaf)) || ((checkStrictly || multiple) && inCheckedPath)) {
        return (
          <i class="el-icon-check el-cascader-node__postfix"></i>
        );
      }
      return (
        <i class="el-icon-arrow-right el-cascader-node__postfix"></i>
      );
    },

    renderContent (h) {
      const { panel, node, config } = this;
      const { checkStrictly, multiple } = config;
      const render = panel.renderLabelFn;
      const vnode = render
        ? render({ node, data: node.data })
        : null;

      const onClickHandle = () => {
        if (checkStrictly && !multiple) {
          this.handleCheckChange();
        }
      };

      return (
        <span class="el-cascader-node__label" onClick={onClickHandle}>
          {vnode || node.label}
        </span>
      );
    }
  },

  render (h) {
    const {
      inActivePath,
      inCheckedPath,
      isChecked,
      isLeaf,
      isDisabled,
      config,
      nodeId
    } = this;
    const { expandTrigger, checkStrictly, multiple } = config;
    const disabled = !checkStrictly && isDisabled;
    const events = { on: {} };

    if (expandTrigger === 'click') {
      events.on.click = this.handleExpand;
    } else {
      events.on.mouseenter = e => {
        this.handleExpand();
        this.$emit('expand', e);
      };
      events.on.focus = e => {
        this.handleExpand();
        this.$emit('expand', e);
      };
    }
    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
      events.on.click = this.handleCheckChange;
    }

    return (
      <li
        role="menuitem"
        id={ nodeId }
        aria-expanded={ inActivePath }
        tabindex={ disabled ? null : -1 }
        class={{
          'el-cascader-node': true,
          'is-selectable': checkStrictly,
          'in-active-path': inActivePath,
          'in-checked-path': inCheckedPath,
          'is-active': isChecked,
          'is-disabled': disabled
        }}
        onMouseenter={ this.handleMouseEnter }
        onMouseleave={ this.handleMouseLeave }
        {...events}>
        { this.renderPrefix(h) }
        { this.renderContent(h) }
        { this.renderPostfix(h) }
      </li>
    );
  }
};
</script>



// WEBPACK FOOTER //
// cascader-node.vue?9eee7694